import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.25 8.5L11.75 16L19.25 8.5", stroke: "#222222", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
